var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-card"},[_c('div',{staticClass:"title-icon"},[_vm._t("icon"),_c('h3',{staticClass:"card-title"},[_vm._t("title")],2)],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }